module.exports = __webpack_public_path__ + "static/foryou-whole-learning.4338b8e3.jpg";